const zh = {
  Groups: {
    title: "小组",
  },
  GroupList: {
    group: "小组",
    dates: "上课日期",
    report: "课程报告",
    statistics: "平台统计",
    progress: "平台进度",
    lessonsCount: "已授课程",
    total: "课时总数",
    finished: "已完成课时",
    left: "剩余课时",
    period: "周期",
    teachers: "教师",
    attendance: "出勤",
  },
  ModalGroupReport: {
    Download: "下载",
    Teacher: "教师",
    Course: "课程",
    Schedule: "时间表",
    Hours: "学时",
    TotalHours: "课时总数",
    CompletedHours: "已完成课时",
    LeftHours: "剩余课时",
    Compensation: "补偿",
    Students: "学生",
    Duration: "时长",
  },
  GroupFilter: {
    Company: "公司",
    ActiveGroups: "活跃小组",
    ActiveGroupsNo: "否",
    ActiveGroupsYes: "是",
    SelectLevel: "选择级别",
    SearchStudent: "搜索学生",
    SearchGroup: "搜索小组",
    SelectModule: "选择模块",
    AllModules: "所有模块",
    StartDate: "开始日",
    EndDate: "结束日",
    WithLessonsWithoutTeachers: "无教师",
    WithLessonsOnlyTechnicalCancellationBefore: "取消课程",
    NoOptions: "没有选项",
    Open: "打开",
  },
  GroupDownload: {
    Download: "下载",
    Groups: "小组",
    WithoutPrice: "无价格小组",
  },
  GroupsAutocompleteFilter: {
    EnterGroupName: "输入小组名称",
    SelectGroup: "选择小组",
  },
  GroupsEmptyTable: {
    FirstTextDefault: "您没有可用的小组。",
    SecondTextDefault: "请联系协调员。",
    FirstTextDistributor: "没有可显示的数据。",
    SecondTextDistributor: "请尝试输入一些数据。",
    FirstTextClasses: "没有可显示的数据。",
    SecondTextClasses: "请尝试更改筛选条件或联系支持人员。",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "未找到教师",
    SelectTeacher: "选择教师",
  },
  ShortWeekDay: {
    "0": "周日",
    "1": "周一",
    "2": "周二",
    "3": "周三",
    "4": "周四",
    "5": "周五",
    "6": "周六",
  },
  LessonStatuses: {
    completed: "已完成",
    planned: "已计划",
    earlyCanceledByCustomer: "学员提前取消的课",
    earlyCanceledBySchool: "教师提前取消的课",
    lateCanceledByCustomer: "学员晚点取消的课",
    lateCanceledBySchool: "教师晚点取消的课",
    notPerformedToPay: "待支付",
  },
  DatePicker: {
    Today: "今天",
    Clear: "清除",
    MaskPlaceholder: "dd/mm/yyyy",
  },
};

export default zh;
